import { useFormContext } from "react-hook-form";
import { withFieldHint } from "@/src/components/HighOrderComponents";
import { DatePickerField } from "@/src/components/Fields/DataPickerField";
import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";
import { USE_SELECT_FIELD_UPDATE_DELAY } from "@/src/shared/const/delay";

const DatePickerWithHint = withFieldHint(DatePickerField);
export function YearInput(props: any) {
  const { hint, name } = props;
  const format = "yyyy";
  const hints = hint?.hintsList;
  const form = useFormContext();
  const { control } = form;

  const debouncedUpdateField = useFieldDebouncedCallback(name, USE_SELECT_FIELD_UPDATE_DELAY);

  return (
    <DatePickerWithHint
      {...props}
      openTo={"year"}
      views={["year"]}
      format={format}
      returnFormat={"yyyy"}
      onChange={(value) => debouncedUpdateField(value)}
      control={control}
      name={name}
      hints={hints}
    />
  );
}
